import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AgentProfile from './components/AgentProfile';
import SEO from '@/components/feature/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://floridahousesforsale.deals';

const aboutSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About Amparo Jarquin – Florida REALTOR®',
    description: 'Learn about Amparo Jarquin, licensed REALTOR® and Florida real estate expert serving buyers and sellers across the state of Florida.',
    url: `${SITE_URL}/about`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'About', item: `${SITE_URL}/about` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Amparo Jarquin',
    jobTitle: 'Licensed REALTOR®',
    url: `${SITE_URL}/about`,
    telephone: '+17726268544',
    email: 'pslucie369@gmail.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'West Palm Beach',
      addressRegion: 'FL',
      postalCode: '33406',
      addressCountry: 'US',
    },
    worksFor: {
      '@type': 'RealEstateAgent',
      name: 'Florida Homes for Sale',
      url: SITE_URL,
    },
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="About Amparo Jarquin | Florida REALTOR® West Palm Beach FL"
        description="Meet Amparo Jarquin, licensed REALTOR® and Florida real estate expert. Dedicated to helping clients buy and sell homes across all of Florida with expertise and care."
        keywords="Amparo Jarquin REALTOR, Florida real estate agent, West Palm Beach realtor, Florida homes expert"
        canonical="/about"
        schema={aboutSchema}
      />
      <Navbar />
      <section className="relative pt-36 pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/c738922ce739b83302141edde5e4b397.jpg"
            alt="Florida homes"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-stone-900/60"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <p className="text-amber-400 text-xs font-semibold tracking-widest uppercase mb-3">Your Trusted Partner</p>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">About Amparo Jarquin</h1>
          <p className="text-white/70 max-w-xl mx-auto text-base">Florida Real Estate Expert &amp; Licensed REALTOR®</p>
        </div>
      </section>
      <AgentProfile />
      <Footer />
    </div>
  );
}
